import type { VideoFields } from '@boss/types/corporate-jobs';

const getVideoProps = (entry: VideoFields) => {
  return {
    src: entry.externalVideoUrl,
    thumbnail: entry.thumbnail,
    alternativeText: entry.alternativeText,
  };
};

export default getVideoProps;
